import React from 'react'
import { withRouter } from 'react-router-dom'
// import ButtonIcon from './components/ButtonIcon';
// import { IconHome } from './Icons'
import ButtonBase from '@material-ui/core/ButtonBase/ButtonBase'
import Grid from '@material-ui/core/Grid/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import { acl } from './Login/Acl'
import { IconArrowDropDown } from './Icons';

const styles = {
    btn: {
        padding: 6,
        paddingLeft: 8,
        paddingRight: 10,
        borderRadius: 4,
        marginRight: 8,
        backgroundImage: 'linear-gradient(#6877ca, #2e3b84)',
    },
    icon: {
        fontSize: 10,
        marginRight: 4,
    },
    label: {
        fontSize: 14,
    },
}

const Menus = ({action1}) => (
    <div style={{paddingTop: 6}}>
         {acl.map((menu, key) => (
            <NavButton key={key} to={menu.linkto} Icon={menu.Icon} label={menu.label} />
        ))}
        <NavButton2 label="Payment" action={action1}/>
    </div>
)

const NavButton1 = withRouter(({ history, to, Icon, label, classes }) => (
    <ButtonBase className={classes.btn} onClick={() => history.push(to)}>
        <Grid alignItems="center" container>
            <Grid className={classes.icon} item>
                <Icon />
            </Grid>
            <Grid className={classes.label} item>
                {label}
            </Grid>
        </Grid>
    </ButtonBase>
))

const NavButton02 = ({classes, action, label}) => (
    <ButtonBase className={classes.btn} onClick={action}>
        <Grid alignItems="center" container>
            <Grid className={classes.label} item>
                {label}
            </Grid>
            <Grid className={classes.icon} item>
                <IconArrowDropDown />
            </Grid>
        </Grid>
    </ButtonBase>
)
const NavButton2 = withStyles(styles)(NavButton02);

const NavButton = withStyles(styles)(NavButton1)

export default Menus
